import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import useCategories from 'hooks/useCategories'
import Layout from 'layouts/help'
import { Container, Wrapper, Categories, Block, Content } from './index.style'

const Help = ({ pageContext: { baseUrl } }) => {
  const categories = useCategories(baseUrl)

  return (
    <Layout baseUrl={baseUrl}>
      <Container>
        <Wrapper>
          <Categories>
            {categories.map(({ name, url, category }) => (
              <Block key={name}>
                <Link to={url}>
                  <Content>
                    <Content.Img category={category} />
                    <Content.Title category={category}>{name}</Content.Title>
                  </Content>
                </Link>
              </Block>
            ))}
          </Categories>
        </Wrapper>
      </Container>
    </Layout>
  )
}

Help.propTypes = {
  pageContext: PropTypes.shape({
    baseUrl: PropTypes.string,
  }),
}

export default Help
